import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Chip } from '@mui/material';

function HeaderBar({ posture, resetCountdown }) {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 1280,
        borderRadius: 2,
        p: { xs: 1, sm: 2 },
        mb: 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 500,
          color: '#3366FF',
          fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
          display: 'flex',
          alignItems: 'center'
        }}
      >
        Yoga Pose Instructor
        {posture?.name && (
          <Chip label={posture.name} color="primary" size="medium" sx={{ ml: 1, fontSize: { xs: '0.8rem', sm: '0.9rem' } }} />
        )}
      </Typography>
    </Box>
  );
}

export default HeaderBar;
